export default [
  {
    path: '/apps/representante/list',
    name: 'apps-representante-list',
    component: () => import('@/views/cadastros/apoio-vendas/representante/list/Index.vue'),
    meta: {
      pageTitle: 'Representantes',
    },
  },
  // {
  //     path: '/apps/representante/edit/:id',
  //     name: 'apps-representante-edit',
  //     component: () => import('@/views/cadastros/apoio-vendas/representante/representante-edit/RepresentanteEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Representante',
  //     },
  // },
];
